import landing from '../assets/landing.png'
import AngieLogo from '../assets/AngieLogo.png'
import rose from '../assets/rose.png'
import roseHd from '../assets/roseHd.png'
import batuBunga from '../assets/batu-bunga.png'
import facial from '../assets/facial.png'
import fb from '../assets/fb.png'
import ig from '../assets/ig.png'
import joan from '../assets/joan.png'
import leblanc from '../assets/leblanc.png'
import dusex from '../assets/dusex.png'
import mcquay from '../assets/mcquay.png'
import tw from '../assets/tw.png'
import roseMassage from '../assets/rose-massage.png'
import roseBath from '../assets/rose-bath.png'
import queensBath from '../assets/queens-bath.png'
import bodyMassage from '../assets/body-massage.png'
import scrub from '../assets/scrub.png'
import rosePetals from '../assets/rose-petals.png'
import arrow from '../assets/arrow.png'
import mobileMenu from '../assets/mobileMenu.png'

export default {
    landing,
    AngieLogo,
    batuBunga,
    facial,
    fb,
    tw,
    ig,
    roseHd,
    roseMassage,
    roseBath,
    queensBath,
    bodyMassage,
    scrub,
    rosePetals,
    rose,
    joan,
    mcquay,
    leblanc,
    dusex,
    arrow,
    mobileMenu
}